import React, { FC } from 'react';
// mui components
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from '@mui/material';
// styles
import './styles.css';

interface IProps {
  data: string[][];
}

const CSVTable: FC<IProps> = ({ data }) => {
  // First row is typically the header
  const [headerRow, ...dataRows] = data;

  return (
    <Box
      className="csv-table-wrapper"
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
        }}
      >
        <Table stickyHeader size="small">
          {headerRow && (
            <TableHead>
              <TableRow>
                {headerRow.map((header, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      fontWeight: 'bold',
                      backgroundColor: '#f5f5f5',
                      border: '1px solid #ddd',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {dataRows.map((row, rowIndex) => (
              <TableRow key={rowIndex} hover>
                {row.map((cell, cellIndex) => (
                  <TableCell
                    key={cellIndex}
                    sx={{
                      border: '1px solid #ddd',
                      whiteSpace: 'nowrap',
                    }}
                    title={cell} // Show full content on hover
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CSVTable;
